import {createFileRoute} from "@tanstack/react-router";
import {getAuthenticationMethodsForUserWithCaching} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/authentication/-queries";
import {getUserTemplatesWithCaching} from "~/utilities/queries";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/account-settings",
)({
    loader: async ({context}) => {
        const userId = context.profileStatus.platformUser.userId;

        const [userTemplatesResult, authenticationMethods] = await Promise.all([
            getUserTemplatesWithCaching({
                workspaceId: context.workspace.id,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                queryClient: context.queryClient,
            }),
            getAuthenticationMethodsForUserWithCaching({
                queryClient: context.queryClient,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                userId,
            }),
        ]);

        if (userTemplatesResult.success !== true) {
            throw new Error("Failed to fetch user templates");
        }

        return {
            accessToken: context.authenticationStatus.accessToken,
            intellsysBaseUrl: context.intellsysBaseUrl,
            userTemplates: userTemplatesResult.data,
            workspace: context.workspace,
            users: context.users,
            authenticationMethods,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
